import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { PartnerFormModal } from "../../components/PartnerFormModal";

export const PartnerBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <section className="partner-banner">
        <div className="partner-banner-content">
          <div className="subtile">{t("partner.banner.subtitle")}</div>
          <div className="title">{t("partner.banner.title")}</div>
          <div className="join-button" onClick={() => setVisible(true)}>
            {t("partner.banner.join")}
          </div>
          <PartnerFormModal {...{ visible, setVisible }} />
        </div>
        <div className="banner-img">
          <img
            src="//files.authing.co/authing-website/partner-banner.png"
            alt="authing"
          />
        </div>
      </section>
    </div>
  );
};
